(ns admin.containers.curriculum.demo.reports-readiness.curriculum-readiness-breakdown
  (:require [admin.containers.curriculum.reports-readiness.shared :as s]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.components.base.text :as text]
            [kyber.components.composite.dropdown :as dropdown]
            [goog.string :as gstring]
            [goog.string.format]
            [kyber.components.base.link :as link]))

(def classes
  (styles->classes
   {:table-container
    {:width "100%"

     "& td, th"
     {:padding [(gs [:spacing :p8])
                (gs [:spacing :p12])]}}

    :table-head
    {:text-align :center

     "& th > *"
     {:margin (gs [:spacing :p0])}}

    :table-body
    {:text-align :center
     :border (str "1px solid " (gs [:colors :gray-scale-200]))

     "& td"
     {:vertical-align :middle
      :border (str "1px solid " (gs [:colors :gray-scale-200]))
      :background-color (gs [:colors :true-white])}}

    :readiness-table-cell
    {:display :flex
     :justify-content :space-between
     :align-items :center}

    :link-title
    {:font-size (gs [:font-size :title-20])}}))

(defn- fmt-learner-count
  "Displays learner counts in the thousands using shorthand"
  [learner-count]
  (if (> learner-count 1000)
    (str (gstring/format "%.1f" (/ learner-count 1000)) "K")
    (str learner-count)))

(defn render
  [{:keys [collection-title collection filter]}]
  [:table {:class [(:table-container classes)]}
   [:thead {:class [(:table-head classes)]}
    [:tr
     [:th {:style {:text-align :left
                   :vertical-align :middle
                   :width "40%"}}
      [text/title-30
       :p
       {:style {:margin-left (str "-" (gs [:spacing :p12]))}}
       collection-title]]
     [:th {:width "40px"}
      [text/caption-20 :p "Learners"]
      [text/title-20 :p "Started"]]
     [:th {:width "40px"}
      [text/caption-20 :p "Learners"]
      [text/title-20 :p "Completed"]]
     [:th {:style {:display :flex
                   :align-items :center
                   :justify-content :center}}
      [:div {:style {:width "100%"}}
       [text/caption-20 :p "Learners"]
       [text/title-20 :p "Readiness"]]
      (when (some? filter)
        [dropdown/render {:value (:value filter)
                          :options (:options filter)
                          :on-change (:on-change filter)}])]]]

   [:tbody
    (for [{:keys [title starters completers distribution cta]} collection]
      [:tr {:key title
            :class [(:table-body classes)]}
       [text/title-20 :td {:style {:text-align :left}}
        (if (some? cta)
          [link/link {:href (:href cta)
                      :class (:link-title classes)} title]
          title)]
       [text/title-30 :td (fmt-learner-count starters)]
       [text/title-30 :td (fmt-learner-count completers)]
       [:td 
        [:div {:style {:display :flex
                       :align-items :center
                       :justify-content :center}}
         [s/readiness-scale {:distribution distribution}]
         (when (some? cta)
           [link/primary-anchor-button
            {:href (:href cta)
             :style {:margin-left (gs [:spacing :p20])}}
            (:label cta)])]]])]])
